import React from 'react';

import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import styles from '../workflow-card.module.scss';

interface Props {
	id?: number;
	title?: string;
}

const RenderErrorFallback = ({ id, title }: Props) => (
	<div className={classNames(styles.workflowCard, styles.workflowRenderError)} data-test-id={`workflow-card-${id}`}>
		<BringgIcon iconName={BringgFontIcons.Warning} className={styles.warningIcon} />
		<span>
			Failed to display workflow {title} (id: <code>{id}</code>)
		</span>
		<span>Please contact support</span>
	</div>
);

export default RenderErrorFallback;
